<template>
    <v-app>
        <scale 
        :model_score="chair_score" 
        :model_comment="chair_comment" 
        :section="section" 
        :contents="contents"
        :title="title"></scale>
    </v-app>
</template>
<script>
import Scale from '@/components/Scale';
import db from '@/components/firebase.init';
export default {
    props:['section'],
    data(){
        return{
            chair_score:[],
            chair_comment:[],
            na: 0,
            title: "Chair",
            contents:[
                {
                    question:"Is the chair adjustable to suit the work tasks?",
                    parts: ['Back', 'Knee', 'Elbow']
                },
                {
                    question:"Does the chair provide the user with lumbar support?",
                    parts: ['Back']
                },
                {
                    question:"Does the chair have five support legs?",
                    parts: ['Back']
                },
                {
                    question:"Does the chair have appropriate casters for the rolling surface (hard/soft surface)?",
                    parts: ['Back']
                },
                {
                    question:"Are the employee’s feet flat on the floor when sitting on the chair?",
                    parts: ['Back', 'Knee']
                },
                {
                    question:"Does the chair have adjustable armrests?",
                    parts: ['Elbow']
                },
                {
                    question:"When sitting on chair, are the employee’s thigh parallel to the floor?",
                    parts: ['Knee']
                },
                {
                    question:"When sitting on chair, are the employee’s knees 90-degree angle",
                    parts: ['Knee']
                },
                {
                    question:"Does the employee have knowledge as to how to adjust the chair",
                    parts: ['General']
                }
            ]
        }
    },
    methods:{
        getTotalScore(){
            let total = 0;
            this.na = 0;
            for(var x = 0; x < this.chair_score.length; x++){
                if(this.chair_score[x] == 'NA'){
                    this.na++;
                }
                else{
                    total += this.chair_score[x]
                }
            }
            
            return total;
        },
        getTotalNa(){
            return this.na;
        },
        invalid(){
            return this.chair_score.length != this.contents.length || this.chair_score.includes(undefined);
        },
        submit(id){
            let score = this.getTotalScore();
            db.collection('forms').doc(id).update(
                {
                    chair_score: this.chair_score,
                    chair_comment: this.chair_comment,
                    chair_total: score
                }
            ).then(data=>{
                
            })
            .catch(e =>{
                alert(e);
            })
        },
        initializeComment(){
            for(var i = 0; i < this.contents.length; i++){
                this.chair_comment[i] = "";
            }
        }
    },
    components:{
        'scale' : Scale
    },
    mounted(){
        this.initializeComment();
    }
}
</script>

